var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: none;\n        stroke: #072f3a;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .cls-2 {\n        fill: #072f3a;\n      }\n    ")),React.createElement("title",{"key":1},"Social-Facebook"),React.createElement("g",{"id":"Layer_2","data-name":"Layer 2","key":2},React.createElement("g",{"id":"Layer_1-2","data-name":"Layer 1"},[React.createElement("circle",{"className":"cls-1","cx":"12","cy":"12","r":"11.5","key":0}),React.createElement("path",{"className":"cls-2","d":"M15.44,9.38H13.17v-1a.56.56,0,0,1,.58-.63h1.36V5.52H12.83a2.4,2.4,0,0,0-2.56,2.73V9.38H8.33v1.93h1.94V18.1h2.9V11.31h2Z","key":1})]))]);
}

Facebook.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = Facebook;

Facebook.default = Facebook;
